export default __webpack_public_path__ + "static/media/user.f56adcde.svg";